import React from "react";
//#region types
import { MultipleSelectionProps } from "models/propTypes/selectionPropTypes";
import { SelectionKeyType } from "models/utilTypes/selectionTypes";
//#endregion
//#region components
import { Chip, Grid, Tooltip } from "@mui/material";
import useMultiSelectionHelpers from "./useMultiSelectionHelpers";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";
import GridR from "../grid/responsiveGrid";

const MultipleSelection: React.FC<MultipleSelectionProps> = (props) => {
  const { items } = useMultiSelectionHelpers(props.items, props.value);

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const key = e.currentTarget.getAttribute("data-key");
    if (props.restrictMultiple) {
      // eslint-disable-next-line eqeqeq --- disabling to avoid regression testing if changed
      props.onChange && props.onChange(items.filter((item) => item.id == key));
    } else {
      // eslint-disable-next-line eqeqeq --- disabling to avoid regression testing if changed
      props.onChange && props.onChange(items.filter((item) => item.selected || item.id == key));
    }
  };

  const handleRemove = (id: SelectionKeyType) => {
    // eslint-disable-next-line eqeqeq --- disabling to avoid regression testing if changed
    props.onChange && props.onChange(items.filter((item) => item.selected && item.id != id));
  };

  return (
    <Grid item container className={clsx(props.className, cssExports.selectionChipsGroup)}>
      <GridR item container className={cssExports.selectionChips} spacing={1} direction="row">
        {items.map((item) => (
          <Tooltip
            key={item.id}
            placement="top"
            title={item.value}
            classes={{ tooltip: cssExports.tooltip, popper: cssExports.tooltipPopper }}
            enterDelay={1000}
            arrow
          >
            <Grid item key={item.id} className={cssExports.chipContainer}>
              <Chip
                key={item.id}
                className={clsx(cssExports.chip, item.selected ? cssExports.selected : "")}
                variant={item.selected ? "filled" : "outlined"}
                data-key={item.id}
                label={item.value}
                clickable
                onClick={handleClick}
                onDelete={
                  item.selected
                    ? () => {
                        handleRemove(item.id as SelectionKeyType);
                      }
                    : undefined
                }
                // eslint-disable-next-line eqeqeq --- disabling to avoid regression testing if changed
                disabled={props.disabled || props.disabledItems?.some((di) => di == item.id)}
              />
            </Grid>
          </Tooltip>
        ))}
      </GridR>
    </Grid>
  );
};

export default MultipleSelection;
